<div class="wrapper cursor-pointer">
  <div class="heading flex items-center">
    <span class="text-type-8 contractor-name mr-[10px]">{{ data?.sub_contractor?.name }}</span>
    @if (data?.sub_contractor?.prime) {
      <span class="prime-pill">Prime</span>
    }
  </div>
</div>
